<ng-container>
  <div class="sdc-logs-list">
    <gp-table (sortChange)="onSortKeyChange($event)" class="table" [class.sdc-admin-table]="!contractId">
      <colgroup *ngIf="!contractId">
        <col style="width: 13%">
        <col style="width: 13%">
        <col style="width: 11%">
        <col style="width: 10%">
        <col style="width: 15%">
        <col style="width: 12%">
        <col style="width: 8%">
        <col style="width: 18%">
      </colgroup>
      <thead gp-table-head>
      <tr role="row">
        <th *ngIf="!contractId" gp-table-column colspan="8" scope="col">
          <div class="pull-left">
            <span class="font-weight-normal italic">Person log statuses: </span>
            <em *ngIf="personLogStatusesLoading" class="fa fa-light fa-spinner fa-spin"></em>
            <ng-container *ngIf="(personLogStatuses$ | async) as personLogStatuses">
              <span *ngFor="let status of personLogStatuses | sort: 'status'">
              {{ status.status }}({{ status.count || 0 }})&nbsp;
            </span>
            </ng-container>
          </div>
          <div class="pull-right">
            <button (click)="reload()"
                    class="btn btn-xs btn-outline-primary"
                    type="button"
                    style="margin-right: 5px">
              <em class="fa fa-rotate-right"></em>
              <span class="m-l-xs">{{ 'CONTEXT_BAR.reload' | translate }}</span>
            </button>
            <button (click)="resetFilters()"
                    [disabled]="noFilterSet()"
                    class="btn btn-xs btn-outline-primary"
                    type="button">
              <em class="fa fa-filter-circle-xmark"></em>
              <span class="m-l-xs">{{ 'CONTEXT_BAR.clear_all_filters' | translate }}</span>
            </button>
          </div>
        </th>
      </tr>
      <tr role="row">
        <th class="column-title text-muted small" gp-table-column id="created" scope="col" sort-key="creationDate">
          {{ 'SDC.created' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column id="updated" scope="col" sort-key="updateDate">
          {{ 'SDC.updated' | translate }}
        </th>
        <th *ngIf="!contractId"
            class="column-title text-muted small"
            gp-table-column
            id="externalReference"
            scope="col"
            sort-key="employeeOtherId1">
          {{ 'SDC.ExternalReference' | translate }}
        </th>
        <th *ngIf="!contractId"
            class="column-title text-muted small"
            gp-table-column
            id="contractId"
            scope="col"
            sort-key="contractId">
          {{ 'EMPLOYEE_HIRE.contract_id' | translate }}
        </th>
        <th *ngIf="!contractId"
            class="column-title text-muted small"
            gp-table-column
            id="payGroup"
            scope="col"
            sort-key="payGroup">
          {{ 'SDC.payGroup' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column id="eventType" scope="col" sort-key="eventType">
          {{ 'SDC.eventType' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column id="status" scope="col" sort-key="status">
          {{ 'COMMON.status' | translate }}
        </th>
        <th *ngIf="!!contractId" class="column-title text-muted small" gp-table-column id="message" scope="col">
          {{ 'COMMON.message' | translate }}
        </th>
        <th class="column-title text-muted small" gp-table-column id="correlationId" scope="col"
            sort-key="correlationId">
          {{ 'SDC.correlationId' | translate }}
        </th>
      </tr>
      <tr *ngIf="!contractId" [formGroup]="filtersForm" class="filters">
        <td>
          <datepicker-input formControlName="creationDate"></datepicker-input>
        </td>
        <td>
          <datepicker-input formControlName="updateDate"></datepicker-input>
        </td>
        <td>
          <input (keydown.enter)="$event.preventDefault()"
                 class="form-control b-a form-group-sm search-field"
                 formControlName="externalReference"
                 type="text">
        </td>
        <td>
          <input (keydown.enter)="$event.preventDefault()"
                 class="form-control b-a form-group-sm search-field"
                 formControlName="contractId"
                 type="text">
        </td>
        <td>
          <input (keydown.enter)="$event.preventDefault()"
                 class="form-control b-a form-group-sm search-field"
                 formControlName="payGroup"
                 type="text">
        </td>
        <td>
          <select class="form-control" formControlName="eventType">
            <option></option>
            <option *ngFor="let eventType of eventTypes.sort()" [value]="eventType">
              {{ eventType }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" formControlName="status">
            <option></option>
            <option *ngFor="let status of statuses.sort()" [value]="status">
              {{ 'EVENT_LOG.level_' + status | translate }}
            </option>
          </select>
        </td>
        <td>
          <input (keydown.enter)="$event.preventDefault()"
                 class="form-control b-a form-group-sm search-field"
                 formControlName="correlationId"
                 type="text">
        </td>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="sdcLogsLoading">
        <td class="text-center p-t-lg p-b-lg" colspan="8">
          <em class="fa fa-light fa-spinner fa-spin"></em>
        </td>
      </tr>
      <ng-container *ngIf="sdcLogs$ | async as sdcLogs">
        <tr (click)="openSidePanel(sdcLog)" *ngFor="let sdcLog of sdcLogs" class="pointer">
          <td headers="created">
            {{
              sdcLog.creationDate | gpDate:{
                withTime: true,
                timezone: timezone
              }
            }}
          </td>
          <td headers="updated">
            {{
              sdcLog.updateDate | gpDate:{
                withTime: true,
                timezone: timezone
              }
            }}
          </td>
          <td *ngIf="!contractId" headers="externalReference">
            {{ sdcLog.employeeOtherId1 }}
          </td>
          <td *ngIf="!contractId" headers="contractId">
            {{ sdcLog.contractId }}
          </td>
          <td *ngIf="!contractId" headers="payGroup" class="nowrap">
            {{ sdcLog.payGroup }}
          </td>
          <td headers="eventType">
            {{ sdcLog.eventType }}
          </td>
          <td headers="status">
            <span class="event-status" [ngClass]="'event-status-' + sdcLog.status">{{ 'EVENT_LOG.level_' + sdcLog.status | translate | uppercase }}</span>
          </td>
          <td *ngIf="contractId" class="event-message" headers="message">
            <textarea class="form-control" readonly>{{ sdcLog.message }}</textarea>
          </td>
          <td class="nowrap" headers="correlationId">
            <span *ngIf="sdcLog.correlationId" class="event-correlation-id">{{ sdcLog.correlationId }}</span>
            <copy-to-clipboard
              *ngIf="sdcLog.correlationId && !contractId"
              [data]="sdcLog.correlationId"
              [toolTipMessageBefore]="'Copy correlation ID'"
              [toolTipMessageAfter]="'Correlation ID copied'">
            </copy-to-clipboard>
          </td>
        </tr>
        <tr *ngIf="sdcLogs.length === 0">
          <td class="text-center p-t-lg p-b-lg" colspan="8">
            {{ 'MENU.SDCONNECT.noLogs' | translate }}
          </td>
        </tr>
      </ng-container>
      </tbody>
    </gp-table>
  </div>
  <gp-table-pagination
    [pagination]="pagination">
  </gp-table-pagination>
</ng-container>
<gp-side-panel (isSidePanelOpenChange)="closeSidePanel()"
               *ngIf="selectedLog"
               [isSidePanelOpen]=!!selectedLog
               [sidePanelTitle]="('SDC.LOG.Details' | translate)">
  <gp-sdc-log [sdcLog]="selectedLog"></gp-sdc-log>
</gp-side-panel>
